var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -2244.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Design",
    transform: "translate(1206.000000, 2244.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.529,24.471 L7.529,16.942 L15.058,24.471 L7.529,24.471 Z M32,32 L0,0 L0,7.53 L1.882,7.53 L1.882,9.412 L0,9.412 L0,13.177 L1.882,13.177 L1.882,15.059 L0,15.059 L0,18.824 L1.882,18.824 L1.882,20.706 L0,20.706 L0,24.471 L1.882,24.471 L1.882,26.353 L0,26.353 L0,28 C0,30.209 1.791,32 4,32 L5.647,32 L5.647,30.117 L7.529,30.117 L7.529,32 L11.294,32 L11.294,30.117 L13.176,30.117 L13.176,32 L16.941,32 L16.941,30.117 L18.823,30.117 L18.823,32 L22.588,32 L22.588,30.117 L24.47,30.117 L24.47,32 L32,32 Z",
    id: 196
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonDesign);
export default __webpack_public_path__ + "static/media/common-design.938145be.svg";
export { ForwardRef as ReactComponent };